// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagAssetModel extends SmartTagModel {
	brand?: string;
	serialNumber?: string;
	modelNumber?: string;
	age?: string;

	constructor() {
		super();
		this.brand = '';
		this.serialNumber = '';
		this.modelNumber = '';
		this.age = '';
	}
}

export class SmartTagAsset extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagAssetModel
	 */
	public render(data: SmartTagAssetModel, version?: string): string {
		this.getData(data);
		
		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagAssetModel): void{
		const title = data.title || data.subCategory || '';
		const brand = data.brand || '';
		const modelNumber = data.modelNumber || '';
		const age = data.age || '';
		const description = data.description?.trim() || ''

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (brand !== '') {
			this.addText(`<span title="${brand}">Brand: ${brand}</span>`);
		}
		if (modelNumber !== '') {
			this.addText(`<span title="${modelNumber}">Model: ${modelNumber}</span>`);
		}
		if (age !== '') {
			this.addText(`<span title="${age}">Age: ${age}</span>`);
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
